export default __webpack_public_path__ + "static/media/bsp2.6f28436a.png";